import { render, staticRenderFns } from "./incomeDetail.vue?vue&type=template&id=5730d00f&scoped=true&"
import script from "./incomeDetail.vue?vue&type=script&lang=js&"
export * from "./incomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./incomeDetail.vue?vue&type=style&index=0&id=5730d00f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730d00f",
  null
  
)

export default component.exports